import React, { Component } from 'react';
import Select from "react-select";
import { toast } from 'react-toastify';
import ModalDm from '../../components/Modal/ModalDm';
import { formatCpfCnpj, buscaCep, formatTelefone } from '../../utils/functions';
import { pathDmService } from '../../services/Api';

class ModalLogistica extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      optionsLogistica: [],
      selectedLogistic: null,
      logisticForm: false,
      logisticsFieldsOk: true,
      cpfcnpj: "",
      razaonome: "",
      cep: "",
      endereco: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      estado: "",
      cuidados: "",
      telefone: "",
      objLogistica: []
    };
  }

  componentDidMount = async () => {
    this.loadLogistics();
  };

  loadLogistics = async () => {
    const options = [
      { id: 1, label: "Irei retirar o material na DMCard" },
      { id: 2, label: "O material deve ser entregue em outro endereço" }
    ];
    this.setState({ optionsLogistica: options });
  };

  createObjLogistica = () => {
    const obj = {
      CpfCnpj: this.state.cpfcnpj,
      RazaoNome: this.state.razaonome,
      Cep: this.state.cep,
      Endereco: this.state.endereco,
      Numero: this.state.numero,
      Complemento: this.state.complemento,
      Bairro: this.state.bairro,
      Cidade: this.state.cidade,
      Estado: this.state.estado,
      Cuidados: this.state.cuidados,
      Telefone: this.state.telefone
    };
    this.isLogisticsOk();
    this.setState({ objLogistica: obj })
  };

  isLogisticsOk = () => {        
    if (!this.state.isEditing)
    {
      this.setState( { logisticsFieldsOk: true });
      return true;
    }
    else
    {      
      var validLogistics = 
            this.state.razaonome != null && this.state.razaonome.length > 0
            && this.state.cpfcnpj != null && this.state.cpfcnpj.length > 10
            && this.state.cuidados != null && this.state.cuidados.length > 0
            && this.state.cep != null && this.state.cep.length > 0
            && this.state.endereco != null && this.state.endereco.length > 0
            && this.state.numero != null && this.state.numero.length > 0     
            && this.state.bairro != null && this.state.bairro.length > 0
            && this.state.cidade != null && this.state.cidade.length > 0
            && this.state.estado != null && this.state.estado.length > 0
            && this.state.telefone != null && this.state.telefone.length > 0;
       
       this.setState( { logisticsFieldsOk: validLogistics });

       return validLogistics;
    }
  }

  onChangeLogistica = item => {
    if (!item) {
      this.setState({
        logisticForm: false,
        selectedLogistic: item
      });
    } else {
      if (item.id === 1) {
        this.setState({
          logisticForm: false,
          selectedLogistic: item
        });
      } else {
        this.createObjLogistica();
        this.setState({
          logisticForm: true,
          selectedLogistic: item
        });
      }
    }
    setTimeout(() => this.isLogisticsOk(), 100);
  };

  onChangeCpfCnpj = async event => {
    await this.setState({
      [event.target.name]: formatCpfCnpj(event.target.value)
    });
  };

  onChangeTextLogistic = async event => {
    await this.setState({ [event.target.name]: event.target.value });
    this.createObjLogistica();
  };

  onChangeCep = async event => {
    const cep = event.target.value;

    if (cep.length < 8) {
      this.setState({
        cep: cep,
        endereco: "",
        bairro: "",
        cidade: "",
        estado: ""
      });
      this.createObjLogistica();
      return;
    } else {
      const result = await buscaCep(cep);
      if (result) {
        this.setState({
          cep: result.cep,
          endereco: result.logradouro,
          bairro: result.bairro,
          cidade: result.localidade,
          estado: result.uf
        });
        this.createObjLogistica();
      } else {
        alert("Cep não existente.");
      }
    }
  };

  onChangeTelefone = async event => {
    await this.setState({
      [event.target.name]: formatTelefone(event.target.value)
    });
    this.createObjLogistica();
  };

  validateFormLogistica = async (formLogistica) => {
    if (formLogistica.CpfCnpj === "")
      return false;
    else if (formLogistica.RazaoNome === "")
      return false;
    else if (formLogistica.Endereco === "")
      return false;
    else if (formLogistica.Numero === "")
      return false;    
    else if (formLogistica.Bairro === "")
      return false;
    else if (formLogistica.Cidade === "")
      return false;
    else if (formLogistica.Estado === "")
      return false;
    else if (formLogistica.Cuidados === "")
      return false;
    else if (formLogistica.Telefone === "")
      return false;
    else
      return true;
  }

  sendLogistica = async e => {
    await this.createObjLogistica();
    const { pedido } = this.props;
    const {
      selectedLogistic,
      objLogistica
    } = this.state;

    if (await this.validateFormLogistica(objLogistica)) {
      e.preventDefault();

      await pathDmService(`/Pedido/AtualizaLogisticaPedido/${selectedLogistic.id}/${pedido}`, objLogistica);

      toast.success("Logistica atualizada com sucesso.");

      await this.close();
      document.location.reload(true);
    }
    else
      toast.error("Existem campos que precisam ser preenchidos.");
  };

  edit = async () => {
    const { logistica } = this.props;
    if (logistica) {
      this.setState({
        isEditing: true,
        razaonome: logistica.razaoNome,
        cpfcnpj: logistica.cpfCnpj,
        cuidados: logistica.cuidados,
        telefone: logistica.telefone,
        cep: logistica.cep,
        endereco: logistica.endereco,
        numero: logistica.numero,
        complemento: logistica.complemento,
        bairro: logistica.bairro,
        cidade: logistica.cidade,
        estado: logistica.estado
      })
    }
    else
      this.setState({ isEditing: true })
  };

  close = async () => {
    const { modal, toggleModal, load } = this.props;
    this.setState({
      isEditing: false,
      selectedLogistic: null,
      logisticForm: false,
      cpfcnpj: "",
      razaonome: "",
      cep: "",
      endereco: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      estado: "",
      cuidados: "",
      telefone: "",
      objLogistica: []
    });
    await load();
    toggleModal(modal);
  };

  render() {
    const { logistica, modal, isOpen, toggleModal } = this.props;
    const {
      optionsLogistica,
      selectedLogistic,
      logisticForm,
      isEditing,
      cpfcnpj,
      razaonome,
      cep,
      endereco,
      numero,
      complemento,
      bairro,
      cidade,
      estado,
      cuidados,
      telefone,
      logisticsFieldsOk
    } = this.state;

    return (
      <ModalDm
        openModal={() => toggleModal(modal)}
        heading="Logistica"
        hiddenModal={() => this.close()}
        openMd={isOpen}
        modalWidth="modalWidth"
      >
        {isEditing ? (
          <div className="bx--row">
            <div className="bx--col-md-12">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Entrega</label>
                <Select
                  className="select-dm"
                  name="logistica"
                  options={optionsLogistica}
                  value={selectedLogistic}
                  onChange={e => this.onChangeLogistica(e)}
                  placeholder="Selecione a opção desejada"
                  isClearable={false}
                  isSearchable={false}
                />
                {logisticForm && (
                  <div>
                    <label className="bx--label">Preencha os dados para entrega</label>
                    <div className="bx--row">
                      <div className="bx--col-xs-6 bx--col-sm-6">
                        <label className="bx--label">Razão social ou Nome Completo (*)</label>
                        <input
                          id="text-input-razao-nome"
                          type="text"
                          className="bx--text-input"
                          name="razaonome"
                          value={razaonome}
                          onChange={e => this.onChangeTextLogistic(e)}
                        />
                        <label className="bx--label">CNPJ ou CPF (*)</label>
                        <input
                          id="text-input-cnpj-cpf"
                          type="text"
                          className="bx--text-input"
                          name="cpfcnpj"
                          value={cpfcnpj}
                          onChange={e => this.onChangeCpfCnpj(e)}
                          maxLength={18}
                        />
                        <label className="bx--label">Nome Completo do responsável pelo recebimento (*)</label>
                        <input
                          id="text-input-cuidados"
                          type="text"
                          className="bx--text-input"
                          name="cuidados"
                          value={cuidados}
                          onChange={e => this.onChangeTextLogistic(e)}
                        />
                        <label className="bx--label">Telefone para contato (*)</label>
                        <input
                          id="text-input-fone"
                          type="text"
                          className="bx--text-input"
                          name="telefone"
                          value={telefone}
                          onChange={e => this.onChangeTelefone(e)}
                          maxLength={15}
                        />
                        <label className="bx--label">CEP (*)</label>
                        <input
                          id="text-input-cep"
                          type="text"
                          className="bx--text-input"
                          name="cep"
                          value={cep}
                          onChange={e => this.onChangeCep(e)}
                          maxLength={8}
                        />
                        <label className="bx--label">Endereço (*)</label>
                        <input
                          id="text-input-endereco"
                          type="text"
                          className="bx--text-input"
                          name="endereco"
                          value={endereco}
                          onChange={e => this.onChangeTextLogistic(e)}
                        />
                        <label className="bx--label">Número (*)</label>
                        <input
                          id="text-input-numero"
                          type="text"
                          className="bx--text-input"
                          name="numero"
                          value={numero}
                          onChange={e => this.onChangeTextLogistic(e)}
                        />
                        <label className="bx--label">Complemento</label>
                        <input
                          id="text-input-endereco"
                          type="text"
                          className="bx--text-input"
                          name="complemento"
                          value={complemento}
                          onChange={e => this.onChangeTextLogistic(e)}
                        />
                        <label className="bx--label">Bairro (*)</label>
                        <input
                          id="text-input-bairro"
                          type="text"
                          className="bx--text-input"
                          name="bairro"
                          value={bairro}
                          onChange={e => this.onChangeTextLogistic(e)}
                        />
                        <label className="bx--label">Cidade (*)</label>
                        <input
                          id="text-input-cidade"
                          type="text"
                          className="bx--text-input"
                          name="cidade"
                          value={cidade}
                          onChange={e => this.onChangeTextLogistic(e)}
                        />
                        <label className="bx--label">Estado (*)</label>
                        <input
                          id="text-input-estado"
                          type="text"
                          className="bx--text-input"
                          name="estado"
                          value={estado}
                          onChange={e => this.onChangeTextLogistic(e)}
                        />
                      </div>
                      <div className="bx--col-xs-6 bx--col-sm-6">
                        <div className="bx--col-xs-12 bx--col-sm-12">
                          <p>{razaonome}</p>
                          <p>{cpfcnpj}</p>
                          <p>{`Responsável: ${cuidados}`}</p>
                          <p>{telefone}</p>
                          <p>{`${endereco}, ${numero}`}</p>
                          <p>{complemento}</p>
                          <p>{`${bairro} - ${cidade}/${estado}`}</p>
                          <p>{`CEP: ${cep}`}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">                      
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => this.close()}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          disabled={logisticForm &&!logisticsFieldsOk}
                          onClick={(e) => this.sendLogistica(e)}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          logistica && (
            logistica.tipoLogistica === 1 ? (
              <div>
                <div className="bx--row">
                  <p>Irei retirar o material na DMCard</p>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={() => this.edit()}
                        >
                          Editar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <p>O material deve ser entregue em outro endereço</p>
                <div className="bx--row">
                  <div className="bx--col-xs-6 bx--col-sm-6">
                    <label className="bx--label">Razão social ou Nome Completo</label>
                    <p>{logistica.razaoNome}</p>
                    <label className="bx--label">CNPJ ou CPF</label>
                    <p>{logistica.cpfCnpj}</p>
                    <label className="bx--label">Nome Completo do responsável pelo recebimento</label>
                    <p>{logistica.cuidados}</p>
                    <label className="bx--label">Telefone para contato</label>
                    <p>{logistica.telefone}</p>
                    <label className="bx--label">CEP</label>
                    <p>{logistica.cep}</p>
                    <label className="bx--label">Endereço</label>
                    <p>{logistica.endereco}</p>
                    <label className="bx--label">Número</label>
                    <p>{logistica.numero}</p>
                    <label className="bx--label">Complemento</label>
                    <p>{logistica.complemento}</p>
                    <label className="bx--label">Bairro</label>
                    <p>{logistica.bairro}</p>
                    <label className="bx--label">Cidade</label>
                    <p>{logistica.cidade}</p>
                    <label className="bx--label">Estado</label>
                    <p>{logistica.estado}</p>
                  </div>
                  <div className="bx--col-xs-6 bx--col-sm-6">
                    <div className="bx--col-xs-12 bx--col-sm-12">
                      <p>{logistica.razaoNome}</p>
                      <p>{logistica.cpfCnpj}</p>
                      <p>{`Responsável: ${logistica.cuidados}`}</p>
                      <p>{logistica.telefone}</p>
                      <p>{`${logistica.endereco}, ${logistica.numero}`}</p>
                      <p>{logistica.complemento}</p>
                      <p>{`${logistica.bairro} - ${logistica.cidade}/${logistica.estado}`}</p>
                      <p>{`CEP: ${logistica.cep}`}</p>
                    </div>
                  </div>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={() => this.edit()}
                        >
                          Editar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          )
        )}
      </ModalDm>
    );
  }
}

export default ModalLogistica;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalLogistica.js